<ul class="side-nav">
  @for (item of menuItems(); track $index) {
    @if (item.isTitle) {
      <li class="side-nav-title">{{ item.label }}</li>
    }

    @if (!item.isTitle) {
      @if (!hasSubMenu(item)) {
        <li app-menu-item [item]="item"></li>
      }

      @if (hasSubMenu(item)) {
        <li app-menu-item-children [item]="item" [class.active]="shouldHighlightParent(item)"></li>
      }
    }
  }
</ul>
